import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@shared';
import { IPaginationParams } from '../interfaces/IPaginationParamas';

@Injectable({
  providedIn: 'root',
})
export class SpecializationsService {
  constructor(private http: HttpClient) {}
  createSpecializations(specializationData: any) {
    return this.http.post<ApiResponse>('/v1/admin/specializations', specializationData);
  }
  getAllSpecializations(params: IPaginationParams) {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    return this.http.get<ApiResponse>('/v1/admin/specializations', { params: httpParams });
  }
  /** How many users hold this type — asked before the delete dialog is shown. */
  getSpecializationUsage(id: string) {
    return this.http.get<ApiResponse>(`/v1/admin/specializations/${id}/user-count`);
  }
  /**
   * `reassignTo` must travel as a query param, not a body: the backend's
   * `@AuditDecorator(DELETE)` replaces the request body with the audit fields.
   */
  deleteSpecialization(id: string, reassignTo?: string) {
    let params = new HttpParams();
    if (reassignTo) params = params.set('reassignTo', reassignTo);
    return this.http.delete<ApiResponse>(`/v1/admin/specializations/${id}`, { params });
  }
  getSpecializationById(id: string | null) {
    return this.http.get<ApiResponse>(`/v1/admin/specializations/${id}`);
  }
  updateSpecialization(id: string | null, specializationData: any) {
    return this.http.put<ApiResponse>(`/v1/admin/specializations/${id}`, specializationData);
  }
  exportSpecializations(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/specializations/export`, filterData, options);
  }
}
